import React from 'react'
import Show from 'services/Show';
import Contest from 'services/Contest';
import { handleErrors, formatDate } from 'services/utils'
import { Spinner } from 'components/atoms';

export default class ShowContests extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      busy: false,
      show: {},
      contests: [],
      showId: match.params.id,
      successSave: false,
    }
    this.changed_contests = [];
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    const showPromise = Show.get(this.state.showId, {with_experts: true}).then(show => {
      if (this.mounted) {
        this.setState( { show, loading: false } );
      }
    });
    showPromise.catch((request) => {
      handleErrors(request);
    });
    const contestsPromise = Contest.query({show_id: this.state.showId}).then(({items, paging}) => {
      if (this.mounted) {
        this.setState( { contests: items, loading: false } );
      }
    })
    contestsPromise.catch((request) => {
      handleErrors(request);
    });
    Promise.all([showPromise, contestsPromise]).then(() => {
      this.setState({ loading: false });
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  saveChanges = (e) => {
    e.preventDefault();
    let itemsToUpdate = [];
    this.setState({ successSave: false, busy:true });
    const savingItems = this.state.contests
                          .filter(item => item.isFieldChanged('expert_id'))
                          .map(item => item.save().then(item => {
                            itemsToUpdate.push(item);
                          }));
    Promise.all(savingItems).then(() => {
      if (!this.mounted) return; 
      const contests = this.state.contests.map(item => {
        const updated = itemsToUpdate.find(updated => updated.id === item.id);
        if (updated) {
          return updated;
        }
        return item;
      });
      this.setState({
        contests, 
        successSave: true, 
        busy: false,
      });
    }).catch((request) => {
      this.setState({busy: false});
      handleErrors(request);
    });
  }

  onChange = (e) => {
    const target = e.target;
    const contestId = target.id.replace(/\D/g, '') * 1;
    const contests = this.state.contests.map(contest => {
      if (contest.id === contestId && contest.expert_id !== target.value * 1) {
        contest.expert_id = target.value;
      }
      return contest;
    });
    this.setState({ contests });
  }

  render() {
    const {show, contests, loading} = this.state;
    let showInfo = null;

    const changed = contests.some(item => item.isFieldChanged('expert_id') );
    
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }

    const expertOptions = (show.invited_experts || []).map(expert => (
      <option key={expert.id} value={expert.id}>{expert.name}</option>)
    );

    return (
      <div className="container-fluid">
        <h4>Конкурсы выставки - {showInfo}</h4>
        {loading && <Spinner /> }

        { this.state.successSave && 
         <div className="row alert alert-success">
          Назначение экспертов на конкурсы выставки успешно обновлено.
         </div>}

        <ul>
          <li className="row mb-2">
            <strong className="col-3">Название конкурса</strong>
            <strong className="col-4"> Эксперт </strong>
          </li>
          {(contests || []).map(contest => {
            const contestChanged = contest.isFieldChanged('expert_id');
            const selectClassName = 'form-select form-select-sm ' + (contestChanged ? ' text-primary' : '')
            return (
            <li key={contest.id} className="row mb-2">
              <div className="col-3">{contest.name}</div>
              <div className="col-4">
                <select id={'contest-'+contest.id} value={contest.expert_id} 
                  className={selectClassName} onChange={this.onChange}>
                  <option>выберите эксперта породы</option>
                  {expertOptions}
                </select>
              </div>
            </li>)
          }
          )}
        </ul>

        <div className="row">
          <div className="col-md-12 mb-3">
            <button type="button" onClick={this.saveChanges} disabled={!changed || this.state.busy} className="btn btn-primary me-2">
              { this.state.busy && <Spinner /> }
              Сохранить
            </button>
            <button type="button" onClick={this.onCancel} disabled={this.state.busy} className="btn btn-light">
              { this.state.busy && <Spinner /> }
              Назад
            </button>
          </div>
        </div>

      </div>
    );
  }
}

